export const ENGLISH_SELECT = {
  key: 'English',
  value: 'en-US',
};

export const SPANISH_SELECT = {
  key: 'Spanish',
  value: 'es-US',
};

export const SAFE_HARBOR_DISCLAIMER_STORAGE_KEY = 'disclosure.timestamp'; // Local storage key for SAFE HARBOR

/*  Approximation of 3 months for storing disclosure agreement (safe harbor) */
export const DISCLOSURE_STORAGE_PERIOD = 3 * 30 * 24 * 60 * 60 * 1000;
